import { useRouter } from 'next/router';
import React from 'react';

import { ROUTES } from '@common/constant/routeConstant';
import { useTranslation } from 'next-i18next';

import Button from '@components/atoms/button';
import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { Role } from '@helpers/constants';
import { useProfile } from '@hooks/useProfile';

type EditCourseButtonProps = {
  courseIdName: string;
};

const EditCourseButton = ({ courseIdName }: EditCourseButtonProps) => {
  const { t } = useTranslation('store_course');
  const { profile } = useProfile();
  const router = useRouter();

  const isShowEditCourseButton = (): boolean => {
    if (!profile) return false;

    return profile.roles.some((role) => [Role.SUPER_ADMIN, Role.COURSE_EDITOR].includes(role.name));
  };

  const onClick = () => {
    router.push(ROUTES.COURSE.EDIT(courseIdName));
  };

  if (!isShowEditCourseButton()) {
    return null;
  }

  return (
    <Button
      variant="outlined"
      color="secondary"
      onClick={onClick}
      startIcon={<FontAwesomeIcon icon="fa-light fa-pen-to-square" style={{ fontSize: '16px' }} />}
    >
      {t('course_detail.header_banner.edit_course.text')}
    </Button>
  );
};

export default EditCourseButton;
